import React, { useState } from 'react';
import Header from '../../components/admin/header/Header';
import SearchKeyword from '../../components/admin/common/SearchKeyword';
import Content from '../../components/admin/review/Content';

export default function Review() {
  // 검색 상태 관리
  const [searchParams, setSearchParams] = useState({
    keyword: '',
    searchType: 'title'
  });

  // 검색 핸들러
  const handleSearch = (params) => {
    console.log('검색 파라미터:', params);
    setSearchParams(params);
  };

  // 검색 초기화 핸들러 (선택사항)
  const handleSearchReset = () => {
    setSearchParams({
      keyword: '',
      searchType: 'title'
    });
  };

  return (
    <>
      <Header></Header>
      <div className="content-wrapper">
        <div className="titleNav">설치사례</div>
        
        <div className="">
          <SearchKeyword 
            placeholder="제목으로 검색"
            searchType="title"
            onSearch={handleSearch}
            initialValue={searchParams.keyword}
            buttonText="검색"
          />
          <Content 
            searchParams={searchParams}
          />
        </div>
      </div>
    </>
  );
}